import React from "react";
import { Builder } from "@builder.io/sdk";

import { marketingCtaClicked } from "@utils/segment/marketingCtaClicked";
import { PrimaryButtonWithArrow } from "../../Buttons";
import BlackCheckmark from "../../SVGIcons/BlackCheckmark/BlackCheckmark";
import BuilderBooleanInput from "@utils/BuilderInputs/BuilderBooleanInput";
import BuilderImageInput from "../../../utils/BuilderInputs/BuilderImageInput";
import BuilderStringInput from "../../../utils/BuilderInputs/BuilderStringInput";
import DropdownWithoutArrow from "@components/Dropdowns/DropdownWithoutArrow";
import setRouteName from "../../../utils/getLocationName";

import styles from "./BannerButtonLarge.module.scss";

type BannerButtonLargeType = {
  bannerBackground: string;
  ctaCopy: string;
  ctaUrl: string;
  header: string;
  subcopy: string;
  bannerList: Array<{ copy: string }>;
  enableClientPractitionerDropDown?: boolean;
  ctaLocation: string;
};

const BannerButtonLarge: React.FC<BannerButtonLargeType> = ({
  bannerBackground,
  ctaCopy,
  ctaUrl,
  header,
  subcopy,
  bannerList,
  enableClientPractitionerDropDown = false,
  ctaLocation,
}) => {
  const routeName = setRouteName();

  const containerStyles = {
    backgroundImage: `url(${bannerBackground})`,
  } as React.CSSProperties;

  const bannerListItems =
    bannerList &&
    bannerList.map((listItem, index) => (
      <li key={index}>
        <BlackCheckmark />
        {listItem.copy}
      </li>
    ));

  const handleBtnWithArrowClick: React.MouseEventHandler<HTMLAnchorElement> =
    e => {
      marketingCtaClicked({
        text: e.currentTarget.textContent as string,
        url: window.location.pathname,
        target: ctaUrl,
      });
    };

  return (
    <div className={styles.container} style={containerStyles}>
      <div className={styles.copyWrapper}>
        <h4
          className={styles.headline}
          dangerouslySetInnerHTML={{ __html: header }}
        />
        <p className={styles.subcopy}>{subcopy}</p>

        <div>
          {enableClientPractitionerDropDown ? (
            <DropdownWithoutArrow
              buttonLink={ctaUrl}
              buttonText={ctaCopy}
              variant="primary-salmon"
              align="left"
            />
          ) : (
            <PrimaryButtonWithArrow
              onClickHandler={handleBtnWithArrowClick}
              buttonLink={ctaUrl}
              buttonText={ctaCopy}
              data-click-type="sign_up_cta"
              data-click-text="Start for free"
              data-click-location={`Footer-${routeName}`}
            />
          )}
          <ul>{bannerListItems}</ul>
        </div>
      </div>
    </div>
  );
};

export default BannerButtonLarge;

export const RegisterBannerButtonLarge = () => {
  Builder.registerComponent(BannerButtonLarge, {
    name: "banner-button-large",
    inputs: [
      new BuilderImageInput("bannerBackground"),
      new BuilderStringInput("ctaCopy"),
      new BuilderStringInput("ctaUrl"),
      new BuilderStringInput("header"),
      new BuilderStringInput("subcopy"),
      new BuilderBooleanInput("enableClientPractitionerDropDown", {
        defaultValue: false,
        friendlyName: "Enable client/practitioner dropdown",
      }),
      {
        name: "bannerList",
        type: "list",
        subFields: [new BuilderStringInput("copy")],
        onChange: (options: any) => {
          const limit = 3;
          const name = "bannerList";
          if (options.get(name).length >= limit) {
            options.set(name, options.get(name).slice(0, limit));
            alert(`maximum items is ${limit}, delete items to continue`);
          }
        },
      },
    ],
  });
};
